module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"view":"View"},"fr":{"view":"Vue"}}')
  delete Component.options._Ctor
}
